import { dropEndpointIds } from 'root/src/shared/drops/drops.constants';
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const sendTargetedDropOutreachEndpoint = {
    [dropEndpointIds.SEND_TARGETED_DROP_OUTREACH]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                dropId: { type: 'string' },
                ratio: { type: 'number' },
                singleSendId: { type: 'string' },
            },
            required: ['dropId', 'ratio', 'singleSendId'],
        },
    },
};
